import { SuportAreaTranslations } from "./suport-area-pt-br";

export const SUPORT_AREA_EN_US: SuportAreaTranslations = {
	title: "Help center",
	questionTitle: "Need help?",
	questionDescription:
		"Open a new ticket or follow up on the ones already in progress with our team.",
	openTicket: "Talk to an agent",
	close: "Close",
};
